import { Select, Text } from '@primer/react';
import * as React from 'react';
export default {
  Select,
  Text,
  React
};